import React from 'react';
import { useEffect, useState, useContext } from "react";
import LinksMenu from "../../../components/Header/LinksMenu";
// import AddProductModal from "../../../components/Modals/AddProductModal";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { BACKURL } from '../../../conf.js'
import Loading from 'react-fullscreen-loading';
import { QtdContext } from "../../../context/qtdContext";
import $api from '../../../http/index.ts'
import { BiSolidSave } from "react-icons/bi";
import { confirmAlert } from 'react-confirm-alert'; // Import
import './react-confirm-alert.css'; // Import css
import Button from '../../../components/Button/Button'
import { FaRegTrashAlt } from "react-icons/fa";

const WeeklyReport = ({ shop, startDate, endDate }) => {
    const [loading, setLoading] = useState(false)
    const { shops, Notify, admin, admins,
        smenas, setSmenas,
        saleReports, setSaleReports,
        shopvneseneenal, setShopvneseneenal,
        incosations, setIncosations,
        contragents

    } = useContext(QtdContext);


    // Хелпер для форматирования даты

    const [revenueTableData, setRevenueTableData] = useState([])
    const [expenseTableData, setExpenseTableData] = useState([])

    const [weekSmenas, setWeekSmenas] = useState([])
    const [weekKassaStart, setWeekKassaStart] = useState(0)
    const [weekKassaEnd, setWeekKassaEnd] = useState(0)
    const [summ_nal_smenas, set_summ_nal_smenas] = useState(0)
    const [summ_zrep_smenas, set_summ_zrep_smenas] = useState(0)
    const [summ_beznal_smenas, set_summ_beznal_smenas] = useState(0)
    const [summ_nal_rashods, set_summ_nal_rashods] = useState(0)
    const [summ_beznal_rashods, set_summ_beznal_rashods] = useState(0)
    const [weekReports, setWeekReports] = useState([])
    const [weekContrRashods, setWeekContrRashods] = useState([])
    const [weekInkassations, setWeekInkassations] = useState([])
    const [weekVnesenie, setWeekVnesenie] = useState([])
    function formatToDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit'
        });
    }
    const submit = async (func, titel, text) => {
        confirmAlert({
            title: titel,
            message: text,
            buttons: [
                {
                    label: 'Да!',
                    onClick: async () => await func()
                },
                {
                    label: 'Отмена!',
                    //   onClick: () => alert('Click No')
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
        });
    };
    // Хелпер для парсинга строки 'дд.мм' обратно в Date (для сортировки)
    function parseDate(dateStr) {
        const [day, month] = dateStr.split('.').map(Number);
        return new Date(new Date().getFullYear(), month - 1, day);
    }

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // месяцы с 0
        const year = String(d.getFullYear()).slice(-2); // последние две цифры года
        const weekdays = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'];
        const weekday = weekdays[d.getDay()];
        return `${day}.${month}.${year} (${weekday})`;
    };
    // function mergeAndFormatWeeklyData({
    //     contrRashods = [],
    //     inkassations = [],
    //     vnesenie = []
    // }) {
    //     const formatted = [];



    //     // Преобразование weekContrRashods
    //     const formattedContrRashods = contrRashods.map((item, idx) =>
    //     //     {
    //     //     return <tr key={idx}>
    //     //         <td className="border p-2">{idx + 1}</td>
    //     //         <td className="border p-2">{formatDate(item.createdAt)}</td>
    //     //         <td className="border p-2">{formatDate(item.doc_date)}</td>
    //     //         <td className="border p-2">{item.doc_number}</td>
    //     //         <td className="border p-2" >{item.kategory}</td>

    //     //         <td className="border p-2">{contragents.find(pr => pr.id == item.contragent_id) ? contragents.find(pr => pr.id == item.contragent_id).name : "?"}</td>
    //     //         <td className="border p-2">{item.nal}</td>
    //     //         <td className="border p-2">{item.beznal}</td>
    //     //     </tr>
    //     // }
    //     (
    //         {
    //             ...item,
    //             date: formatDate(item.createdAt),
    //             number_doc: 0,
    //             doc_date: formatDate(item.doc_date),
    //             doc_number: item.doc_number,
    //             type: item.kategory,   // <-- подставь нужное поле
    //             supplier: contragents.find(pr => pr.id == item.contragent_id) ? contragents.find(pr => pr.id == item.contragent_id).name : "?",   // <-- подставь нужное поле
    //             amount: Number(item.nal),      // <-- подставь нужное поле
    //             nonCash: Number(item.beznal),    // <-- подставь нужное поле
    //             render: <tr key={`${idx}c`}>
    //                 <td className="border p-2">{idx + 1}</td>
    //                 <td className="border p-2">{formatDate(item.createdAt)}</td>
    //                 <td className="border p-2">{formatDate(item.doc_date)}</td>
    //                 <td className="border p-2">{item.doc_number}</td>
    //                 <td className="border p-2" >{item.kategory}</td>

    //                 <td className="border p-2">{contragents.find(pr => pr.id == item.contragent_id) ? contragents.find(pr => pr.id == item.contragent_id).name : "?"}</td>
    //                 <td className="border p-2">{Number(item.nal)}</td>
    //                 <td className="border p-2">{Number(item.beznal)}</td>
    //             </tr>
    //         }
    //     )
    //     );

    //     // Преобразование weekInkassations
    //     const formattedInkassations = inkassations.map((item, idx) =>
    //     //     {
    //     //     return <tr key={idx}>
    //     //         <td className="border p-2">{idx + 1}</td>
    //     //         <td className="border p-2">{formatDate(item.createdAt)}</td>

    //     //         <th className="border p-2"  colSpan={3}>
    //     //             Инкассация
    //     //         </th>

    //     //         <td className="border p-2">{admins.find(pr => pr.id == item.admin_id).fullname}</td>
    //     //         <td className="border p-2">{item.money}</td>
    //     //         <td className="border p-2">{0}</td>
    //     //     </tr>
    //     // }
    //     // }
    //     ({
    //         ...item,
    //         date: formatDate(item.createdAt),
    //         doc_date: '',
    //         number_doc: 0,
    //         doc_number: '',
    //         type: 'Инкассация',   // <-- подставь нужное поле
    //         supplier: admins.find(pr => pr.id == item.admin_id).fullname,   // <-- подставь нужное поле
    //         amount: item.money,      // <-- подставь нужное поле
    //         nonCash: 0,
    //         render: <tr key={`${idx}i`}>
    //             <td className="border p-2">{idx + 1}</td>
    //             <td className="border p-2">{formatDate(item.createdAt)}</td>

    //             <th className="border p-2" style={{ color: 'red' }} colSpan={3}>
    //                 Инкассация
    //             </th>

    //             <td className="border p-2">{admins.find(pr => pr.id == item.admin_id).fullname}</td>
    //             <td className="border p-2">{item.money}</td>
    //             <td className="border p-2">{0}</td>
    //         </tr>
    //     })
    //     );

    //     // Преобразование weekVnesenie
    //     const formattedVnesenie = vnesenie.map(item => (item, idx) =>
    //     //     {
    //     //     return <tr key={idx}>
    //     //         <td className="border p-2">{idx + 1}</td>
    //     //         <td className="border p-2">{formatDate(item.createdAt)}</td>

    //     //         <th className="border p-2" colSpan={3}>
    //     //             Внесенее наличных
    //     //         </th>

    //     //         <td className="border p-2">{admins.find(pr => pr.id == item.admin_id).fullname}</td>
    //     //         <td className="border p-2">{item.money}</td>
    //     //         <td className="border p-2">{0}</td>
    //     //     </tr>
    //     // }
    //     ({
    //         ...item,
    //         date: formatDate(item.createdAt),
    //         doc_date: '',
    //         number_doc: 0,
    //         doc_number: '',
    //         type: 'Внесенее наличных',   // <-- подставь нужное поле
    //         supplier: admins.find(pr => pr.id == item.admin_id).fullname,   // <-- подставь нужное поле
    //         amount: item.money,      // <-- подставь нужное поле
    //         nonCash: 0,
    //         render: <tr key={`${idx}v`}>
    //             <td className="border p-2">{idx + 1}</td>
    //             <td className="border p-2">{formatDate(item.createdAt)}</td>

    //             <th className="border p-2" colSpan={3}>
    //                 Внесенее наличных
    //             </th>

    //             <td className="border p-2">{admins.find(pr => pr.id == item.admin_id).fullname}</td>
    //             <td className="border p-2">{item.money}</td>
    //             <td className="border p-2">{0}</td>
    //         </tr>
    //     })
    //     );

    //     formatted.push(
    //         ...formattedContrRashods,
    //         ...formattedInkassations,
    //         ...formattedVnesenie
    //     );

    //     // Сортировка по createdAt (в формате даты строки — нужно сравнивать как Date)
    //     return formatted.sort((a, b) => {
    //         console.log(a)
    //         const dateA = new Date(a.createdAt);
    //         const dateB = new Date(b.createdAt);
    //         return dateA - dateB;
    //     }).map(d, index => { return { ...d, number_doc: index + 1 } });
    // }
    function mergeAndFormatWeeklyData({
    contrRashods = [],
    inkassations = [],
    vnesenie = [],


}) {
    const formattedContrRashods = contrRashods.map((item) => ({
        ...item,
        date: formatDate(item.createdAt),
        doc_date: formatDate(item.doc_date),
        doc_number: item.doc_number,
        type: item.kategory,
        supplier: contragents.find(pr => pr.id == item.contragent_id)?.name || "?",
        amount: Number(item.nal),
        nonCash: Number(item.beznal),
        origin: 'contrRashods',
    }));

    const formattedInkassations = inkassations.map((item) => ({
        ...item,
        date: formatDate(item.createdAt),
        doc_date: '',
        doc_number: '',
        type: 'Инкассация',
        supplier: admins.find(pr => pr.id == item.admin_id)?.fullname || "?",
        amount: Number(item.money),
        nonCash: 0,
        origin: 'inkassations',
    }));

    const formattedVnesenie = vnesenie.map((item) => ({
        ...item,
        date: formatDate(item.createdAt),
        doc_date: '',
        doc_number: '',
        type: 'Внесенее наличных',
        supplier: admins.find(pr => pr.id == item.admin_id)?.fullname || "?",
        amount: Number(item.money),
        nonCash: 0,
        origin: 'vnesenie',
    }));

    // Сортируем все вместе
    const merged = [
        ...formattedContrRashods,
        ...formattedInkassations,
        ...formattedVnesenie,
    ].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

    // Присваиваем number_doc и генерируем render с правильной нумерацией
    const result = merged.map((item, index) => ({
        ...item,
        number_doc: index + 1,
        render: (
            <tr key={`${index}${item.origin[0]}`}>
                <td className="border p-2">{index + 1}</td>
                <td className="border p-2">{item.date}</td>

                {item.origin === 'contrRashods' ? (
                    <>
                        <td className="border p-2">{item.doc_date}</td>
                        <td className="border p-2">{item.doc_number}</td>
                        <td className="border p-2">{item.type}</td>
                    </>
                ) : (
                    <th className="border p-2" colSpan={3} style={{ color: item.origin !== 'contrRashods' ? 'red' : undefined }}>
                        {item.type}
                    </th>
                )}

                <td className="border p-2">{item.supplier}</td>
                <td className="border p-2">{item.amount}</td>
                <td className="border p-2">{item.nonCash}</td>
            </tr>
        )
    }));

    return result;
}

    const formatDate2 = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // месяцы с 0
        const year = String(d.getFullYear()); // последние две цифры года

        return `${day}.${month}.${year}`;
    };
    useEffect(() => {
        const GetWeekReportByShop = async () => {
            try {
                setLoading(true)
                console.log(startDate, endDate)
                const data = await $api.post(`${BACKURL}/api/weekreports/getweekreportbyshop/${shop.id}`, {
                    startDate: formatDate2(startDate),
                    endDate: formatDate2(endDate),
                })
                console.log(data.data)
                setWeekSmenas(data.data.weekSmenas)
                setWeekKassaStart(data.data.weekSmenas[0].kassa_start)
                setWeekReports(data.data.weekReports)
                setWeekContrRashods(data.data.weekContrRashods)
                setWeekInkassations(data.data.weekInkassations)
                setWeekVnesenie(data.data.weekVnesenie)
                const mergedData = mergeAndFormatWeeklyData({
                    contrRashods: data.data.weekContrRashods,
                    inkassations: data.data.weekInkassations,
                    vnesenie: data.data.weekVnesenie
                });
                let amountNalRashod = 0
                let amountBeznalRashod = 0

                let amountNal = 0
                let amountBeznal = 0
                let amountZreport = 0

                for (let i = 0; i < mergedData.length; i++) {
                    amountNalRashod = amountNalRashod + Number((mergedData[i].amount))
                    amountBeznalRashod = amountBeznalRashod + Number((mergedData[i].nonCash))
                }
                set_summ_beznal_rashods(amountBeznalRashod.toFixed(2))
                set_summ_nal_rashods(amountNalRashod.toFixed(2))
                for (let i = 0; i < data.data.weekSmenas.length; i++) {
                    amountNal = amountNal + Number(data.data.weekSmenas[i].nal)
                    amountBeznal = amountBeznal + Number(data.data.weekSmenas[i].beznal)
                    amountZreport = amountZreport + Number(data.data.weekSmenas[i].z_otchet)

                }
                set_summ_zrep_smenas(amountZreport)
                set_summ_beznal_smenas(amountBeznal)
                set_summ_nal_smenas(amountNal)
                setExpenseTableData(mergedData)
                setWeekKassaEnd((Number(data.data.weekSmenas[0].kassa_start) + Number(amountNal) - Number(amountNalRashod)).toFixed(2))

                setRevenueTableData(data.data.weekSmenas.map((smena, index) => {
                    return {
                        ...smena,
                        id: smena.id,
                        admin_id: smena.admin_id,
                        date: `${formatDate(smena.createdAt)}`,
                        zReport: smena.z_otchet,
                        cash: smena.nal, sbp: 0, card: smena.beznal, total: smena.money + 0, hours: smena.hours, kassa_start: smena.kassa_start, kassa_ost: smena.kassa_ost
                    }
                }

                ))


                setLoading(false)
            } catch (e) {
                console.log(e)
                setLoading(false)
            }



        }
        GetWeekReportByShop()
    }, [])
    return (<>
        <div className="p-4 bg-white rounded-lg shadow-md mb-6">
            <h1 className="text-xl font-semibold mb-2">
                {shop.name}
            </h1>
            <h2 className="text-xl font-semibold mb-2">
                Неделя: {formatDate(startDate)} — {formatDate(endDate)}
            </h2>

            {/* Таблица Выручка */}
            <h3 className="text-lg font-medium mb-2">Выручка</h3>
            <div className="mb-6" style={{ width: '100%', overflowX: 'auto' }}>

                <table className="w-full table-auto border border-collapse border-gray-300" style={{ width: '100%', overflowX: 'auto' }}>
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="border p-2">Действия</th>
                            <th className="border p-2">Дата</th>
                            <th className="border p-2">Менеджер</th>
                            <th className="border p-2">Часы</th>
                            <th className="border p-2">Касса Утро, руб</th>
                            <th className="border p-2">Касса Вечер, руб</th>
                            <th className="border p-2">Z-отчет, руб</th>
                            <th className="border p-2">Наличные, руб</th>
                            <th className="border p-2">СБП, руб</th>
                            <th className="border p-2">Безнал, руб</th>
                            <th className="border p-2">Итого, руб</th>
                        </tr>
                    </thead>
                    <tbody>
                        {revenueTableData.map((row, idx) => {
                            const adm = admins.find(ad => ad.id == row.admin_id)
                            console.log(row)
                            return (
                                <tr key={idx} style={{ background: row.open ? 'rgba(128, 128, 128, 0.29)' : '' }}>
                                    <td className="border p-2">{!row.open &&
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>


                                            <BiSolidSave onClick={() =>
                                                submit(console.log(row), 'Изменение смены', `Вы уверены что хотите изменить смену?`)

                                            } />
                                            <FaRegTrashAlt style={{ color: 'red' }} />
                                        </div>

                                    }</td>
                                    <td className="border p-2">{row.date}</td>
                                    <th className="border p-2">{adm.fullname}</th>
                                    <th className="border p-2">
                                        <input style={{ width: '100%' }} value={row.hours} onChange={(e) => {
                                            console.log(weekSmenas, row, e.target.value)
                                            setRevenueTableData(revenueTableData.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, hours: Number(e.target.value) }
                                                } else return pr
                                            }))
                                            setWeekSmenas(weekSmenas.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, hours: Number(e.target.value) }
                                                } else return pr
                                            }))
                                        }}></input></th>
                                    <th className="border p-2">
                                        <input style={{ width: '100%' }} value={row.kassa_start} onChange={(e) => {
                                            setRevenueTableData(revenueTableData.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, kassa_start: Number(e.target.value) }
                                                } else return pr
                                            }))
                                            setWeekSmenas(weekSmenas.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, kassa_start: Number(e.target.value) }
                                                } else return pr
                                            }))
                                        }}></input></th>
                                    <th className="border p-2">
                                        <input style={{ width: '100%' }} value={row.kassa_ost} onChange={(e) => {
                                            setRevenueTableData(revenueTableData.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, kassa_ost: Number(e.target.value) }
                                                } else return pr
                                            }))
                                            setWeekSmenas(weekSmenas.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, kassa_ost: Number(e.target.value) }
                                                } else return pr
                                            }))
                                        }}></input></th>

                                    <th className="border p-2">
                                        <input style={{ width: '100%' }} value={row.zReport} onChange={(e) => {
                                            setRevenueTableData(revenueTableData.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, zReport: Number(e.target.value) }
                                                } else return pr
                                            }))
                                            setWeekSmenas(weekSmenas.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, zReport: Number(e.target.value) }
                                                } else return pr
                                            }))
                                        }}></input></th>
                                    <th className="border p-2">
                                        <input style={{ width: '100%' }} value={row.cash} onChange={(e) => {
                                            setRevenueTableData(revenueTableData.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, cash: Number(e.target.value) }
                                                } else return pr
                                            }))
                                            setWeekSmenas(weekSmenas.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, cash: Number(e.target.value) }
                                                } else return pr
                                            }))
                                        }}></input></th>
                                    <th className="border p-2">
                                        {row.sbp}
                                    </th>
                                    <th className="border p-2">
                                        <input style={{ width: '100%' }} value={row.card} onChange={(e) => {
                                            setRevenueTableData(revenueTableData.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, card: Number(e.target.value) }
                                                } else return pr
                                            }))
                                            setWeekSmenas(weekSmenas.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, card: Number(e.target.value) }
                                                } else return pr
                                            }))
                                        }}></input></th>
                                    <th className="border p-2">
                                        <input style={{ width: '100%' }} value={row.total} onChange={(e) => {
                                            setRevenueTableData(revenueTableData.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, total: Number(e.target.value) }
                                                } else return pr
                                            }))
                                            setWeekSmenas(weekSmenas.map(pr => {
                                                if (pr.id == row.id) {
                                                    return { ...pr, total: Number(e.target.value) }
                                                } else return pr
                                            }))
                                        }}></input></th>


                                </tr>
                            )
                        })}
                        <tr>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2">{summ_zrep_smenas}руб</th>
                            <th className="border p-2">{summ_nal_smenas}руб</th>
                            <th className="border p-2">0руб</th>
                            <th className="border p-2">{summ_beznal_smenas}руб</th>
                            <th className="border p-2"></th>
                        </tr>
                        <tr>
                            <th className="border p-2" colSpan={4}>
                                Касса на начало периода:
                            </th>
                            <th className="border p-2">{weekKassaStart}руб</th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                        </tr>
                        <tr>
                            <th className="border p-2" colSpan={4}>
                                Касса на конец периода:
                            </th>
                            <th className="border p-2">{weekKassaEnd}руб</th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            {/* Таблица Расходы */}
            <div className="mb-6" style={{ width: '100%', overflowX: 'auto' }}>
                <h3 className="text-lg font-medium mb-2">Расходы</h3>
                <div style={{ display: 'flex', width: '60%', flexDirection: 'row', justifyContent: 'space-between', alignItems: "center" }}>
                    <Button text='+ накладная' width='auto' padding='0 15px' margin='0' color='white' background='orange' onClick={() => console.log('+')} />
                    <Button text='+ инкассация' width='auto' padding='0 15px' margin='0' color='white' background='orange' onClick={() => console.log('+')} />
                    <Button text='+ внесение' width='auto' padding='0 15px' margin='0' color='white' background='orange' onClick={() => console.log('+')} />

                </div>
                <table className="w-full table-auto border border-collapse border-gray-300" style={{ width: '100%', overflowX: 'auto' }}>
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="border p-2">№</th>
                            <th className="border p-2">Дата</th>
                            <th className="border p-2">Дата накладной</th>
                            <th className="border p-2">Номер</th>
                            <th className="border p-2">Наименование</th>
                            <th className="border p-2">Поставщик</th>
                            <th className="border p-2">Сумма</th>
                            <th className="border p-2">Б/н</th>
                        </tr>
                    </thead>
                    <tbody>
                        {expenseTableData.map(row => { console.log(row); return <>{row.render}</> })}
                        {/* {expenseTableData.map((row, idx) => 
{return (row.render)} */}
                        {/* // <tr key={idx}>
                            //     <td className="border p-2">{idx + 1}</td>
                            //     <td className="border p-2">{row.date}</td>
                            //     <td className="border p-2">{row.doc_date}</td>
                            //     <td className="border p-2">{row.doc_number}</td>
                            //     <td className="border p-2" style={{ color: row.type == 'Инкассация' ? 'red' : 'black' }}>{row.type}</td>

                            //     <td className="border p-2">{row.supplier}</td>
                            //     <td className="border p-2">{row.amount}</td>
                            //     <td className="border p-2">{row.nonCash}</td>
                            // </tr>
                        )}*/}

                        <tr>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2"> </th>
                            <th className="border p-2"></th>
                            <th className="border p-2"></th>
                            <th className="border p-2">Итого</th>
                            <th className="border p-2">{summ_nal_rashods}руб</th>
                            <th className="border p-2">{summ_beznal_rashods}руб</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div >
        {loading && (
            <Loading loading background="rgba(255, 165, 0,0.75)" loaderColor="#3498db"></Loading>

        )
        }
    </>
    );
};

export default WeeklyReport;
